<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'page-video-header',
          title: 'Page Video Header',
          active: 1,
          image: '/images/general-bg.jpg',
          color: 'revinre',
          opacity: '8',
          pad_t: '15',
          pad_r: '0',
          pad_b: '11',
          pad_l: '0',
          pre_btn: [],
          h1: 'Sell your home Save thousands',
          h1_color: 'black',
          h1_size: '70',
          h1_desc: '0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google',
          h1_desc_color: 'black',
          post_btn: [],
          video_bg_color: 'black',
          video_image_url: '/fm/revinre/logos/revinre_video_placeholder.png',
          video_url: 'https://www.youtube.com/embed/SglNxlFUOjM?si=yBI_npIqJGyO4RzW&autoplay=1&rel=0',
          social_icons: 1,
        },

        show_video: false,
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> H1 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h1" Title="H1 Title :" v-tippy content="Page title"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.h1_color" Title="H1 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" Min="1" Max="150" v-model="pc.h1_size" Title="H1 title size : "></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="String List, Single" v-model="pc.h1_desc_color" Title="H1 description color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-12">
            <label>H1 description :</label>
            <CkRichEditor v-model="pc.h1_desc" v-tippy content="Page description appearing below the H1 header"></CkRichEditor>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Video player :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.video_bg_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.video_image_url" Title="Placeholder image URL :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.video_url" Title="Video embed URL :"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Social icons :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.social_icons" Title="Social icons :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display social media icon links at the base of the header?"></w-field>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? formatImage(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">
        <div class="row justify-content-center">
          <div class="col-sm-5">
            <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="row mb-5">
              <div v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="col-sm px-sm-1">
                <a :href="btn['url']" class="btn btn-lg px-5 mb-2 mb-sm-0" :class="'btn-'+btn['color']" data-aos="fade-zoom-in">
                  <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
                  <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
                  {{ btn['text'] }}
                  <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
                  <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
                </a>
              </div>
            </div>
            <h1 class="mb-3" data-aos="fade-zoom-in" :class="'text-'+pc['h1_color']+(pc['h1_size'] > 0 ? ' _f-s-'+pc['h1_size'] : '')">{{pc['h1']}}</h1>
            <div class="pb-5" v-html="pc['h1_desc']"></div>
            <div v-if="pc['post_btn'] && pc['post_btn'].length" class="row mt-5">
              <div v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="col-sm px-sm-1">
                <a :href="btn['url']" class="btn btn-lg px-5 mb-2 mb-sm-0" :class="'btn-'+btn['color']" data-aos="fade-zoom-in">
                  <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
                  <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
                  {{ btn['text'] }}
                  <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
                  <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-7">
            <div class="position-relative ml-5 overflow-hidden _p-t-53p _box-shadow-0-1-10-b-8 _b-r-5" :class="'bg-'+pc['video_bg_color']">
              <div v-if="!show_video && pc['video_image_url']" class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 _c-pointer grow" @click="!pc['video_url'] || show_video ? show_video = false : show_video = true">
                <img :src="formatImage(pc['video_image_url'])" class="w-100 h-100">
                <div v-if="pc['video_url']" class="position-absolute _pos-t-50p _pos-l-50p _transform-both-n50p"><Icon icon="ri:youtube-fill" height="100" style="color:#ff0000;" /><div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-white m-4 _z-n1"></div></div>
              </div>
              <div v-else-if="pc['video_url']" class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0">
                <iframe :src="pc['video_url']" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="w-100 h-100"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pc['social_icons']" class="position-absolute _pos-l-0 _pos-b-0 _pos-r-0 text-center">
        <ul class="list-inline">
          <li v-if="website['site_facebook']" class="list-inline-item mx-3" v-tippy content="Visit us on Facebook"><a :href="website['site_facebook']" target="_blank" data-aos="fade-zoom-in" :class="'text-'+pc['h1_color']"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
          <li v-if="website['site_instagram']" class="list-inline-item mx-3" v-tippy content="Visit us on Twitter"><a :href="website['site_instagram']" target="_blank" data-aos="fade-zoom-in" :class="'text-'+pc['h1_color']"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
          <li v-if="website['site_twitter']" class="list-inline-item mx-3" v-tippy content="Visit us on Instagram"><a :href="website['site_twitter']" target="_blank" data-aos="fade-zoom-in" :class="'text-'+pc['h1_color']"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
          <li v-if="website['site_youtube']" class="list-inline-item mx-3" v-tippy content="Visit us on YouTube"><a :href="website['site_youtube']" target="_blank" data-aos="fade-zoom-in" :class="'text-'+pc['h1_color']"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
        </ul>
      </div>
    </div>
  </section>

</template>
